export default class AssignedUsersEditorChangesHandler {
    constructor({
        editor,
        assignedUserModelExtender = assigned => ({}),
        changeCallback = () => {},
    }) {
        this.editor = editor;
        this.assignedUserModelExtender = assignedUserModelExtender;
        this.changeCallback = changeCallback
        this.addedIds = {};
    }

    handleUserDelete(userId) {
        delete this.addedIds[userId];
        this._updateEditorState();
        this.changeCallback()
    }

    handleAssignedUsersChange(addedUserIds, removedUserIds) {
        addedUserIds.forEach(id => this.addedIds[id] = true);
        removedUserIds.forEach(id => delete this.addedIds[id]);
        this._updateEditorState();
        this.changeCallback()
    }

    getAddedUserIds() {
        return Object.keys(this.addedIds)
    }

    extendEditorState(state) {
        return {
            ...state,
            users: state.users.map(user => {
                if (user.canBeModified) {
                    return {...user, ...this.assignedUserModelExtender(!!this.addedIds[user.id])}
                } else {
                    return user
                }
            })
        }
    }

    _updateEditorState() {
        const editor = this.editor;
        editor.setState(this.extendEditorState(editor.state));
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/createLightbox/AssignedUsersEditorChangesHandler.js